import React from 'react'
import { Link } from 'react-router-dom'

function BlogSection() {
  return (
    <>
    <section className="ttm-row blog-section clearfix">
    <div className="container">
      {/* row */}
      <div className="row">
        <div className="col-lg-12">
          {/* section title */}
          <div className="section-title style2">
            <div className="title-header">
              <h3>NEW BLOGS</h3>
              <h2 className="title">Latest <b>News And Articles!</b></h2>
            </div>
          </div>{/* section title end */}
        </div>
      </div>
      <div className="row slick_slider mb_15" data-slick="{&quot;slidesToShow&quot;: 3, &quot;slidesToScroll&quot;: 1, &quot;arrows&quot;:false, &quot;dots&quot;:false, &quot;autoplay&quot;:true, &quot;infinite&quot;:true, &quot;responsive&quot;: [{&quot;breakpoint&quot;:1024,&quot;settings&quot;:{&quot;slidesToShow&quot;: 3}} , {&quot;breakpoint&quot;:900,&quot;settings&quot;:{&quot;slidesToShow&quot;: 2}}, {&quot;breakpoint&quot;:575,&quot;settings&quot;:{&quot;slidesToShow&quot;: 1}}]}">
        <div className="col-lg-4">
          {/* featured-imagebox-post */}
          <div className="featured-imagebox featured-imagebox-post style1">
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/blog/blog-01-600x430.jpg" alt="" />
            </div>
            <div className="featured-content">
              {/* ttm-box-post-date */}
              <div className="ttm-box-post-date">
                <span className="ttm-entry-date">
                  <time className="entry-date" dateTime="2021-03-18T04:16:25+00:00">18<span className="entry-month entry-year">Mar</span></time>
                </span>
              </div>{/* ttm-box-post-date end */}
              <div className="post-meta">
                <span className="ttm-meta-line byline">John Doe</span>
                <span className="ttm-meta-line comments-link">0 Comments</span>
              </div>
              <div className="featured-title">
                <h3><Link to="/blog-single">Choosing the Right Fabric: The Key to Quality,
                    Comfort &amp; Style</Link></h3>
              </div>
              <div className="featured-desc">
                <p>Fabric selection plays a pivotal role in garment manufacturing, significantly
                  influencing...</p>
              </div>
              <a className="ttm-btn ttm-btn-size-md ttm-btn-color-dark btn-inline" href="blog-single" tabIndex={-1}>read more</a>
            </div>
          </div>{/* featured-imagebox-post end */}
        </div>
        <div className="col-lg-4">
          {/* featured-imagebox-post */}
          <div className="featured-imagebox featured-imagebox-post style1">
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/blog/blog-03-600x430.jpg" alt="" />
            </div>
            <div className="featured-content">
              {/* ttm-box-post-date */}
              <div className="ttm-box-post-date">
                <span className="ttm-entry-date">
                  <time className="entry-date" dateTime="2021-02-15T04:15:25+00:00">15<span className="entry-month entry-year">Feb</span></time>
                </span>
              </div>{/* ttm-box-post-date end */}
              <div className="post-meta">
                <span className="ttm-meta-line byline">John Doe</span>
                <span className="ttm-meta-line comments-link">0 Comments</span>
              </div>{/* post-meta end */}
              <div className="featured-title">
                <h3><Link to="/blog-double">The Role of Third-Party Quality Inspections in
                    Textiles and Garments</Link></h3>
              </div>
              <div className="featured-desc">
                <p>Quality assurance is a fundamental aspect of the textile and garment
                  industry, ...</p>
              </div>
              <a className="ttm-btn ttm-btn-size-md ttm-btn-color-dark btn-inline" href="blog-double" tabIndex={-1}>read more</a>
            </div>
          </div>{/* featured-imagebox-post end */}
        </div>
        <div className="col-lg-4">
          {/* featured-imagebox-post */}
          <div className="featured-imagebox featured-imagebox-post style1">
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/blog/blog-02-600x430.jpg" alt="" />
            </div>
            <div className="featured-content">
              {/* ttm-box-post-date */}
              <div className="ttm-box-post-date">
                <span className="ttm-entry-date">
                  <time className="entry-date" dateTime="2021-02-28T04:15:42+00:00">28<span className="entry-month entry-year">Feb</span></time>
                </span>
              </div>
              <div className="post-meta">
                <span className="ttm-meta-line byline">John Doe</span>
                <span className="ttm-meta-line comments-link">0 Comments</span>
              </div>{/* post-meta end */}
              <div className="featured-title">
                <h3><Link to="/blog-triple">Fashion Trends Through Time: Evolution, Influence
                    &amp; Future Insights</Link></h3>
              </div>
              <div className="featured-desc">
                <p>Fashion trends have continually evolved, influenced by a wide array of
                  factors ...</p>
              </div>
              <a className="ttm-btn ttm-btn-size-md ttm-btn-color-dark btn-inline" href="blog-triple">read more</a>
            </div>
          </div>{/* featured-imagebox-post end */}
        </div>
  
      </div>
    </div>
  </section>


    </>
  
  )
}

export default BlogSection